// extracted by mini-css-extract-plugin
module.exports = {"dot":"kL","department":"kM","departmentContent":"kN","departmentbiggerText":"kO","departmentText":"kP"};